export const FREDELUX_AGENCY_EMAIL = 'contact@fredeluxagency.com'
